import { render, staticRenderFns } from "./WritingtypeNewEdit.vue?vue&type=template&id=cba91754&scoped=true&"
import script from "./WritingtypeNewEdit.vue?vue&type=script&lang=js&"
export * from "./WritingtypeNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba91754",
  null
  
)

export default component.exports